import AppRoutes from 'router/AppRoutes';
import { useDynatraceSessionTrackingContext } from 'utils/dynatrace';

function App() {
  useDynatraceSessionTrackingContext();
  return <AppRoutes />;
}

export default App;
